/** Supported telemetry event names for this frontend. */
export const AppInsightsEvents = {
    ApplicationStarted: "Application.Started",
    WebsiteVisited: "Application.WebsiteVisited",
    ButtonClicked: "Application.ButtonClicked",
    PageExited: "Application.PageExited",
    StageViewed: "Application.StageViewed",
    StageNavigation: "Application.StageNavigation",
    StageNavigationBlocked: "Application.StageNavigationBlocked",
    SubmitConfirmationOpened: "Application.SubmitConfirmationOpened",
    SubmitAttempted: "Application.SubmitAttempted",
    SubmitSucceeded: "Application.SubmitSucceeded",
    SubmitFailed: "Application.SubmitFailed",
    SaveAttempted: "Application.SaveAttempted",
    SaveCompleted: "Application.SaveCompleted",
    SaveFailed: "Application.SaveFailed",
    ModificationLockInvalidated: "Application.ModificationLockInvalidated",
    UnhandledException: "Application.UnhandledException",
} as const;

/** The app insights event names */
export type AppInsightsEventName = (typeof AppInsightsEvents)[keyof typeof AppInsightsEvents];

/** Primitive telemetry property values. */
export type AppInsightsPropertyValue = string | number | boolean;

/** Properties attached to telemetry events. */
export type AppInsightsEventProperties = {
    [key: string]: AppInsightsPropertyValue | null | undefined;
};
